export default __webpack_public_path__ + "media/images/favicon-66d16d4282e02d5092e0d1858e3492aa.svg";